import React from 'react';

const FooterV2 = () => {
  return (
    <footer className="py-24 bg-slate-950 text-slate-300">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 text-sm flex flex-col sm:flex-row justify-between gap-2">
        <span>© {new Date().getFullYear()} Shalender Kumar</span>
        <span>Portfolio V2</span>
      </div>
    </footer>
  );
};

export default FooterV2;
